import { BASEMAP_KEYS, BASEMAP_LABELS, type BasemapKey } from '../layers/basemaps'

interface BasemapPopoverProps {
  value: BasemapKey
  onChange: (key: BasemapKey) => void
}

export function BasemapPopover({ value, onChange }: BasemapPopoverProps) {
  return (
    <div className="absolute bottom-[60px] left-1/2 z-50 w-[220px] -translate-x-1/2 rounded-2xl border border-slate-900/10 bg-white/92 px-3.5 py-3 shadow-lg backdrop-blur-md">
      <h5 className="text-muted-text mb-1.5 text-[10px] font-bold tracking-wide uppercase">Basemap</h5>
      {BASEMAP_KEYS.map((key) => (
        <label key={key} className="flex cursor-pointer items-center gap-2 py-1 text-[13px]">
          <input type="radio" name="gis-basemap" checked={value === key} onChange={() => onChange(key)} />
          {BASEMAP_LABELS[key]}
        </label>
      ))}
    </div>
  )
}
